'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.ExterneOrganisationSchema = {
  title: 'ExterneOrganisation',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/externeOrganisation.js
// module id = PHnj
// module chunks = 0